import { RECORD_USER_ACTION } from "@/components/activity/ducks/Actions"
import { apiRecordUserAction } from "@/components/activity/ducks/AJAX"
import { NavigationActions } from "@/components/navigation/ducks/slice"

export default (store) => (next) => (originalAction) => {
  const action = originalAction
  const { dispatch } = store

  switch (action.type) {
    case RECORD_USER_ACTION: {
      apiRecordUserAction(action.params, null, action.error)
      if (
        ["AddressClick", "EmailClick", "PhoneNumberClick"].indexOf(action.params.actionType) !== -1
      ) {
        const conversion = {
          AddressClick: "address",
          EmailClick: "email",
          PhoneNumberClick: "phone number",
        }

        dispatch(NavigationActions.setSnackbar(`Copied ${conversion[action.params.actionType]}`))
      }
      return next(action)
    }

    default:
      return next(action)
  }
}
